<template>
  <div class="maintain-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t('Maintain.Return_to_Maintain_list')}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100">
            <FormItem :label="$t('Maintain.DeviceName')">
              <Input class="info" v-model="device" disabled></Input>
            </FormItem>
            <FormItem :label="$t('Maintain.username')">
              <Input class="info" v-model="operator" disabled></Input>
            </FormItem>
            <FormItem :label="$t('Maintain.startTime')">
              <Input class="info" v-model="startTime" disabled></Input>
            </FormItem>
            <FormItem :label="$t('Maintain.endTime')">
              <Input class="info" v-model="endTime" disabled></Input>
            </FormItem>
            <FormItem :label="$t('Maintain.remark')">
              <Input class="info" v-model="remark" :placeholder="$t('Maintain.please_enter')"></Input>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t('Maintain.save')}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'MaintainEdit',
  data () {
    return {
      id: 0,
      device: '',
      operator: '',
      startTime: '',
      endTime: '',
      remark: '',
      deviceList: []
    }
  },
  computed: {
    title () {
      return this.$t('Maintain.Return_to_Maintain_list')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let m = {
        id: this.id,
        DeviceName: this.device,
        username: this.operator,
        startTime: this.startTime,
        endTime: this.endTime,
        remark: this.remark
      }
      Api.maintain.save(m).then(() => {
        this.$router.push({'name': 'MaintainList'})
      })
    }
  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (id !== 0) {
      Api.maintain.get(id).then(res => {
        let m = res.maintain
        next(vm => {
          vm.id = m.id
          vm.device = m.DeviceName
          vm.operator = m.username
          vm.startTime = m.startTime
          vm.endTime = m.endTime
          vm.remark = m.remark
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .maintain-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// Edit.vue?3b0bf54f